'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:PermissionCtrl
 * @description
 * # PermissionCtrl
 * Controller of the ribytRsvpApp
 */
/* global notificationService */
angular.module( 'ribytRsvpApp' )
    .controller( 'PermissionCtrl', ['$scope', '$rootScope', '$q', 'moment', '$http', '$window', 'ENV', '$sessionStorage', '$state', 'variableSubstitution', '$timeout', 'messageDictionary', 'notificationService',
        function permissionCtrl ( $scope, $rootScope, $q, moment, $http, $window, ENV, $sessionStorage, $state, $variableSubstitution, $timeout, $messageDictionary, notificationService ) {
        // currentRsvpStatus is used to hide view logic until we know for sure what rsvp value definitely will be
        // this prevents flash of content that may not be relevant
        $rootScope.currentRsvpStatus = null; // update this with correct value after we want to enable the view
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;
        $rootScope.currentTab = 'permission';
        $scope.form = {
            values: {
                password: '',
                email: ''
            },
            errors: {
                password: '',
                email: ''
            }
        };
        // byt list
        $scope.bytList = [];
        $scope.passwordData = '';

        // init invite var
        var invite = {}; // will get later with a promise

        init() // get the final invite, possibly via async call
            .then( function render ( finalInvite ) {
                invite = finalInvite;

                // set the rootscope.rsvpProcess variable. If it doesn't exist, that means they just landed.
                // if they said yes or no, they are at welcome
                if (!_.has( $rootScope, 'rsvpProcess' )) {
                    _.set( $rootScope, 'rsvpProcess', 'password' );
                } else if (invite.rsvp === 'y' || invite.rsvp === 'n') {
                    _.set( $rootScope, 'rsvpProcess', 'welcome' );
                }

                $rootScope.rsvp = invite.rsvp;

                // Get needed invite data
                $scope.inviteData = getInviteData( invite );
                if ( !invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP && invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo ) {
                    invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo;
                }
                if ( !invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal && invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo ) {
                    invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo;
                }
                var allowEditToDateRSVP = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP && moment.tz( invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP.split( '+' )[0], invite.eventID.location.timezone ).isAfter( moment() );
                var allowEditToDatePersonal = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal && moment.tz( invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal.split( '+' )[0], invite.eventID.location.timezone ).isAfter( moment() );

                $rootScope.allowEditPersonalInfo = invite.experienceID.RSVPDetails.isGuestCanUpdatePersonalInfo && allowEditToDatePersonal;
                $rootScope.allowEditRSVP = invite.experienceID.RSVPDetails.isGuestCanUpdateRSVP && allowEditToDateRSVP;

                // Create byt list

                // if there is some discrepancy with the back button
                // redirect state to the rsvpProcess variable only allow introduction and welcome here
                if (!_.includes( ['', null, undefined, 'introduction', 'welcome'], invite.rsvpProcess )) {
                    // leave it alone but set $root tab to null
                    $rootScope.currentTab = null;
                }

                // OK, Now we are ready to enable the view, we have the correct invite data
                $rootScope.currentRsvpStatus = invite.rsvp; // enable the overall view by setting this variable

            } )
            .catch( function err ( error ) {
                if (error) {
                    notificationService.error( $messageDictionary.error.completeRSVPIssue );
                }
            } );

        // Init stuff
        function init () {
            invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

            return $q( function ( resolve, reject ) {
                /**
                 * First, check if that state name is complete since we share this controller and
                 * view. If it's complete and the rsvp is p, send them back to the real
                 * introduction page as they should not see this page.
                 */
                if (
                    _.get( $state, 'current.name' ) === 'main.complete' &&
                    $rootScope.isFinishedRSVPProcess( invite ) &&
                    _.get( invite, 'rsvp' ) === 'p'
                ) {
                    $rootScope.setRSVPToYes( invite, function rsvpYCallback ( error, response ) {
                        if (error) {
                            console.log( error );
                            return reject( $messageDictionary.error.completeRSVPIssue );
                        }

                        invite.rsvp = 'y'; // manually set to y on success and use session invite
                        invite.rsvpProcess = 'welcome'; // manually set to y on success and use session invite

                        return resolve( invite );
                    } );
                } else {
                    return resolve( invite );
                }
            } );
        }

        // Get invite data for scope
        function getInviteData ( invite ) {

            var data = {
                'eventName': ( _.get( invite, 'experienceID.isGroupNamePriority' ) ) ? _.get( invite, 'experienceID.name', '' ) : _.get( invite, 'eventID.name', '' ),
                'acceptButtonText': _.get( invite, 'experienceID.RSVPDetails.acceptButtonText', $messageDictionary.general.acceptButtonText ),
                'declineButtonText': _.get( invite, 'experienceID.RSVPDetails.declineButtonText', $messageDictionary.general.declineButtonText ),
                'permissionType': {
                    isRegistrationLimited: _.get( invite, 'experienceID.RSVPDetails.isRegistrationLimited' ),
                    isExperiencePassword: _.get( invite, 'experienceID.RSVPDetails.isExperiencePassword' )
                },
                'rsvp': _.get( invite, 'rsvp' ),
                'type': _.get( invite, 'type' ),
                'acceptMessage': _.get( invite, 'experienceID.RSVPDetails.acceptMessage', $messageDictionary.general.acceptGuestMessage ),
                'declineMessage': _.get( invite, 'experienceID.RSVPDetails.declineMessage', $messageDictionary.general.declineGuestMessage ),
                'acceptMessageCompanion': _.get( invite, 'experienceID.RSVPDetails.acceptMessageCompanion', $messageDictionary.general.acceptGuestMessage ),
                'declineMessageCompanion': _.get( invite, 'experienceID.RSVPDetails.declineMessageCompanion', $messageDictionary.general.declineGuestMessage ),
                'displayByts': _.get( invite, 'experienceID.RSVPDetails.displayByts', true ),
                'isAllowPublicRSVP': ( _.get( invite, 'experienceID.RSVPDetails.isAllowPublicRSVP' ) && _.get( invite, 'experienceID.RSVPDetails.landingPage.enabled' ) )
            };
            _.each( data, function each ( v, k ) {
                // send the newest invite data to the substitution service RPT-2548
                data[k] = $variableSubstitution.doSubstitutions( v, invite );
            } );

            // Setup the location
            var eventLocation = '';
            var locationVenue = _.get( invite.eventID, 'location.venue', null );

            if (locationVenue) {
                eventLocation += locationVenue;
            } else {
                var eventCity = _.get( invite, 'eventID.location.city', null );
                var eventState = _.get( invite, 'eventID.location.state', null );

                if (eventCity) {
                    eventLocation += eventCity;
                }

                if (eventState) {
                    eventLocation += ', ' + eventState;
                }
            }

            // End location setup

            // Setup the location
            data.location = eventLocation;
            // End location setup

            // Setup dates
            var dateStart = moment.utc( invite.experienceID.dateStart ).format( 'M/D/YYYY' );
            var dateEnd = moment.utc( invite.experienceID.dateEnd ).format( 'M/D/YYYY' );

            if (dateStart === dateEnd) {
                // If it's a one day event, just show the day
                _.set( data, 'dateLabel', 'Date: ' );
                _.set( data, 'dates', dateStart );
            } else {
                _.set( data, 'dates', dateStart + ' - ' + dateEnd );
            }
            // End dates

            return data;
        }

        $scope.verify = function () {
            var data = {
                'eventID': invite.eventID.id,
                'experienceID': invite.experienceID.id,
                'password': $scope.form.values.password,
                'email': $scope.form.values.email
            };

            $http.post( ENV.apiEndpoint + '/ribyt/rsvp/confirmPermission', data )
                .then( function success () {
                    var navigation = 'main.introduction';
                    $rootScope.passwordAccepted = true;
                    $rootScope.guestSignInData = {
                        email: $scope.form.values.email
                    };

                    if (_.get( invite, 'rsvp' ) === 'p' && _.get( invite, 'experienceID.landingPageCustomization.enabled' ) === false) {
                        return $rootScope.accept( invite );
                    }

                    if ($rootScope.parameters && $rootScope.parameters.rsvpStatus) {
                        if (_.get( $rootScope, 'parameters.rsvpSkip' ) && !$rootScope.isHasCompanions( invite ) && !$rootScope.isHasLegals( invite ) && $rootScope.getRequiredFields( _.get( invite, 'experienceID.guestInformation.params' ), _.get( invite, 'experienceID.guestInformation.paramsRequired' ) ).length === 0) {
                            return $rootScope.setRSVPToFinalYes( invite );
                        }
                        if ($rootScope.parameters.rsvpStatus) {
                            invite.rsvp = 'y';
                            invite.rsvpProcess = 'guestProfile';
                            $rootScope.redirectProperly( invite );
                        }
                    } else {
                        if ($rootScope.navigatedState && ( $rootScope.navigatedState !== $state.current.name )) {
                            navigation = $rootScope.navigatedState;
                        }

                        $state.go( navigation, {
                            'inviteHash': _.get( $rootScope, 'inviteHash', null ),
                            'gid': _.get( $rootScope, 'parameters.gid' ),
                            'rsvpStatus': _.get( $rootScope, 'parameters.rsvpStatus' )
                        } );
                    }
                }, function err ( err ) {
                    if (_.get( err, 'data.data.isGuestRegistered' )) {
                        notificationService.error( err.data.data.message );
                        $rootScope.inviteHash = err.data.data.inviteHash;
                        $rootScope.currentRsvpStatus = 'y';

                        return $state.go( 'main.introduction', {
                            'inviteHash': _.get( $rootScope, 'inviteHash', null )
                        }, {reload: true} );
                    }

                    $scope.form.errors.password = err.data.error_description.password;
                    $scope.form.errors.email = err.data.error_description.email;
                } );
        };
    }] );
